/* eslint-disable @typescript-eslint/no-explicit-any */
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

// eslint-disable-next-line react-refresh/only-export-components
export const pageLoader = (
  <LoadingOutlined style={{ color: "#213547", fontSize: 24 }} spin />
);

export const CustomSpin = (props: any) => {
  return <Spin indicator={pageLoader} {...props} />;
};

export const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9.58332" cy="9.58341" r="7.91667" stroke="#878787" />
    <path
      d="M15.4167 15.4167L18.3333 18.3334"
      stroke="#878787"
      stroke-linecap="round"
    />
  </svg>
);

export const FilterIcon = () => (
  <svg
    width="15"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1824 0H1.81764C0.368337 0 -0.496119 1.59629 0.307811 2.78803L5.07589 9.02287C5.47333 9.61203 5.68541 10.3043 5.68541 11.0123V15.7682C5.68541 16.567 6.66269 16.9671 7.23426 16.4022L9.04885 14.609C9.219 14.4408 9.31459 14.2127 9.31459 13.9749V11.0123C9.31459 10.3043 9.52667 9.61203 9.92411 9.02287L14.6922 2.78803C15.4961 1.59629 14.6317 0 13.1824 0Z"
      fill="#28303F"
    />
  </svg>
);

export const ToteIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5777 2.43152L13.5777 1.38197C11.8221 0.460656 10.9443 0 10 0C9.05573 0 8.17792 0.460655 6.42229 1.38197L6.10057 1.5508L15.0236 6.64967L19.0403 4.64132C18.3941 3.90949 17.3515 3.36234 15.5777 2.43152Z"
      fill="#0085AD"
    />
    <path
      d="M19.7484 5.96434L15.75 7.96353V11C15.75 11.4142 15.4142 11.75 15 11.75C14.5858 11.75 14.25 11.4142 14.25 11V8.71353L10.75 10.4635V19.904C11.4679 19.7252 12.2848 19.2965 13.5777 18.618L15.5777 17.5685C17.7294 16.4393 18.8052 15.8748 19.4026 14.8603C20 13.8458 20 12.5833 20 10.0585V9.94151C20 8.04885 20 6.86557 19.7484 5.96434Z"
      fill="#0085AD"
    />
    <path
      d="M9.25 19.904V10.4635L0.251639 5.96434C0 6.86557 0 8.04885 0 9.94151V10.0585C0 12.5833 0 13.8458 0.597397 14.8603C1.19479 15.8748 2.27062 16.4393 4.42228 17.5685L6.42229 18.618C7.71524 19.2965 8.53208 19.7252 9.25 19.904Z"
      fill="#0085AD"
    />
    <path
      d="M0.959692 4.64132L10 9.16147L13.4112 7.4559L4.52456 2.37785L4.42229 2.43152C2.64855 3.36234 1.6059 3.90949 0.959692 4.64132Z"
      fill="#0085AD"
    />
  </svg>
);

export const PriorityIcon = () => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5455 6.06076L1.50001 1.75574V0.749988C1.50001 0.33525 1.16476 0 0.750023 0C0.336023 0 0 0.33525 0 0.749988V2.25V11.25V17.25C0 17.6647 0.335988 18 0.749988 18C1.16473 18 1.49998 17.6647 1.49998 17.25V11.7443L11.5455 7.43927C11.8215 7.32154 12 7.05002 12 6.75004C12 6.45005 11.8215 6.1785 11.5455 6.06076Z"
      fill="#FF3B30"
    />
  </svg>
);

export const PrioritySmallIcon = () => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5455 6.06076L1.50001 1.75574V0.749988C1.50001 0.33525 1.16476 0 0.750023 0C0.336023 0 0 0.33525 0 0.749988V2.25V11.25V17.25C0 17.6647 0.335988 18 0.749988 18C1.16473 18 1.49998 17.6647 1.49998 17.25V11.7443L11.5455 7.43927C11.8215 7.32154 12 7.05002 12 6.75004C12 6.45005 11.8215 6.1785 11.5455 6.06076Z"
      fill="#FF3B30"
    />
  </svg>
);

export const TrolleyIcon = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.31443 5.73049L7.82886 7.59256C8.31386 9.34813 8.55637 10.2259 9.26936 10.6252C9.98234 11.0244 10.8874 10.7892 12.6974 10.3188L14.6173 9.81987C16.4274 9.34947 17.3324 9.11426 17.7441 8.42274C18.1557 7.73122 17.9132 6.85344 17.4282 5.09788L16.9138 3.2358C16.4288 1.48023 16.1863 0.602444 15.4733 0.203194C14.7603 -0.196056 13.8552 0.0391459 12.0452 0.50955L10.1253 1.00849C8.31524 1.47889 7.41021 1.71409 6.99856 2.40562C6.58692 3.09714 6.82943 3.97493 7.31443 5.73049Z"
      fill="#0085AD"
    />
    <path
      d="M0.0274902 2.24694C0.13823 1.84781 0.551566 1.61402 0.950702 1.72476L2.6544 2.19744C3.57129 2.45183 4.2969 3.15866 4.55003 4.07489L6.70106 11.8609L6.85935 12.4075C7.49249 12.6438 8.0363 13.0866 8.38143 13.6747L8.69141 13.579L17.5615 11.2739C17.9624 11.1697 18.3719 11.4102 18.4761 11.8111C18.5803 12.212 18.3397 12.6214 17.9388 12.7256L9.10151 15.0223L8.77282 15.1238C8.76607 16.3947 7.88924 17.5555 6.56236 17.9003C4.97189 18.3136 3.33709 17.3982 2.91092 15.8556C2.48476 14.313 3.42861 12.7274 5.01908 12.3141C5.0979 12.2936 5.17682 12.2764 5.2557 12.2623L3.10419 4.47433C2.99592 4.08242 2.67897 3.76092 2.25338 3.64284L0.549679 3.17016C0.150542 3.05942 -0.0832493 2.64608 0.0274902 2.24694Z"
      fill="#0085AD"
    />
  </svg>
);

export const ScanIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="3"
      width="18"
      height="18"
      rx="2"
      stroke="white"
      strokeWidth="2"
      fill="none"
    />
    <path
      d="M8 8H16M8 16H16"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const LocationPinIcon = () => (
  <svg
    width="15"
    height="21"
    viewBox="0 0 15 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 19.25C13.9142 19.25 14.25 19.5858 14.25 20C14.25 20.4142 13.9142 20.75 13.5 20.75H1.5C1.08579 20.75 0.75 20.4142 0.75 20C0.75 19.5858 1.08579 19.25 1.5 19.25H13.5ZM7.5 0C11.366 0 15 3 15 7.5C15 11.4274 10.125 17 7.5 17C4.87505 17 0.000179534 11.0387 0 7.11133C0 3.00022 3.63401 0 7.5 0ZM7.5 4.5C6.11929 4.5 5 5.61929 5 7C5 8.38071 6.11929 9.5 7.5 9.5C8.88071 9.5 10 8.38071 10 7C10 5.61929 8.88071 4.5 7.5 4.5Z"
      fill="#0085AD"
    />
  </svg>
);

export const LeftIcon = () => (
  <svg
    width="10"
    height="21"
    viewBox="0 0 10 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.65079 0.240762C10.0701 0.600184 10.1187 1.23148 9.75926 1.65081L2.31708 10.3334L9.75926 19.0159C10.1187 19.4352 10.0701 20.0665 9.65079 20.4259C9.23147 20.7854 8.60017 20.7368 8.24074 20.3175L0.240743 10.9841C-0.0802478 10.6097 -0.0802478 10.057 0.240743 9.68256L8.24074 0.349227C8.60017 -0.0700991 9.23147 -0.118661 9.65079 0.240762Z"
      fill="#101010"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 9C1.5 6.17157 1.5 4.75736 2.37868 3.87868C3.25736 3 4.67157 3 7.5 3H10.5C13.3284 3 14.7426 3 15.6213 3.87868C16.5 4.75736 16.5 6.17157 16.5 9V10.5C16.5 13.3284 16.5 14.7426 15.6213 15.6213C14.7426 16.5 13.3284 16.5 10.5 16.5H7.5C4.67157 16.5 3.25736 16.5 2.37868 15.6213C1.5 14.7426 1.5 13.3284 1.5 10.5V9Z"
      stroke="white"
    />
    <path d="M5.25 3V1.875" stroke="white" stroke-linecap="round" />
    <path d="M12.75 3V1.875" stroke="white" stroke-linecap="round" />
    <path d="M1.875 6.75H16.125" stroke="white" stroke-linecap="round" />
    <path
      d="M13.5 12.75C13.5 13.1642 13.1642 13.5 12.75 13.5C12.3358 13.5 12 13.1642 12 12.75C12 12.3358 12.3358 12 12.75 12C13.1642 12 13.5 12.3358 13.5 12.75Z"
      fill="white"
    />
    <path
      d="M13.5 9.75C13.5 10.1642 13.1642 10.5 12.75 10.5C12.3358 10.5 12 10.1642 12 9.75C12 9.33579 12.3358 9 12.75 9C13.1642 9 13.5 9.33579 13.5 9.75Z"
      fill="white"
    />
    <path
      d="M9.75 12.75C9.75 13.1642 9.41421 13.5 9 13.5C8.58579 13.5 8.25 13.1642 8.25 12.75C8.25 12.3358 8.58579 12 9 12C9.41421 12 9.75 12.3358 9.75 12.75Z"
      fill="white"
    />
    <path
      d="M9.75 9.75C9.75 10.1642 9.41421 10.5 9 10.5C8.58579 10.5 8.25 10.1642 8.25 9.75C8.25 9.33579 8.58579 9 9 9C9.41421 9 9.75 9.33579 9.75 9.75Z"
      fill="white"
    />
    <path
      d="M6 12.75C6 13.1642 5.66421 13.5 5.25 13.5C4.83579 13.5 4.5 13.1642 4.5 12.75C4.5 12.3358 4.83579 12 5.25 12C5.66421 12 6 12.3358 6 12.75Z"
      fill="white"
    />
    <path
      d="M6 9.75C6 10.1642 5.66421 10.5 5.25 10.5C4.83579 10.5 4.5 10.1642 4.5 9.75C4.5 9.33579 4.83579 9 5.25 9C5.66421 9 6 9.33579 6 9.75Z"
      fill="white"
    />
  </svg>
);

export const ClockIcon = (color: string) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.33333 6.33333H5.83333C5.83333 6.54855 5.97105 6.73962 6.17522 6.80767L6.33333 6.33333ZM6.83333 3.41667C6.83333 3.14052 6.60948 2.91667 6.33333 2.91667C6.05719 2.91667 5.83333 3.14052 5.83333 3.41667H6.33333H6.83333ZM7.92522 7.39101C8.18719 7.47833 8.47035 7.33675 8.55767 7.07478C8.645 6.81281 8.50342 6.52965 8.24145 6.44232L8.08333 6.91667L7.92522 7.39101ZM6.33333 6.33333H6.83333V3.41667H6.33333H5.83333V6.33333H6.33333ZM6.33333 6.33333L6.17522 6.80767L7.92522 7.39101L8.08333 6.91667L8.24145 6.44232L6.49145 5.85899L6.33333 6.33333ZM12.1667 6.33333H11.6667C11.6667 9.27885 9.27885 11.6667 6.33333 11.6667V12.1667V12.6667C9.83114 12.6667 12.6667 9.83114 12.6667 6.33333H12.1667ZM6.33333 12.1667V11.6667C3.38781 11.6667 1 9.27885 1 6.33333H0.5H0C0 9.83114 2.83553 12.6667 6.33333 12.6667V12.1667ZM0.5 6.33333H1C1 3.38781 3.38781 1 6.33333 1V0.5V0C2.83553 0 0 2.83553 0 6.33333H0.5ZM6.33333 0.5V1C9.27885 1 11.6667 3.38781 11.6667 6.33333H12.1667H12.6667C12.6667 2.83553 9.83114 0 6.33333 0V0.5Z"
      fill={color}
    />
  </svg>
);

export const RightIconBW = (color: string) => (
  <svg
    width="9"
    height="12"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 3H0.5M8.5 3L6.21429 5.5M8.5 3L6.21429 0.5"
      stroke={color}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const RightIconBlue = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 8.5C2.72386 8.5 2.5 8.72386 2.5 9C2.5 9.27614 2.72386 9.5 3 9.5V9V8.5ZM3 9V9.5H15V9V8.5H3V9Z"
      fill="#0085AD"
    />
    <path
      d="M10.5 4.5L15 9L10.5 13.5"
      stroke="#0085AD"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ToteIconGrey = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.1833 3.32364L11.6833 2.53648C10.3666 1.84549 9.7082 1.5 9 1.5C8.2918 1.5 7.63344 1.84549 6.31672 2.53647L6.07543 2.6631L12.7677 6.48726L15.7802 4.98099C15.2956 4.43212 14.5136 4.02175 13.1833 3.32364Z"
      fill="#878787"
    />
    <path
      d="M16.3113 5.97326L13.3125 7.47264V9.75C13.3125 10.0607 13.0607 10.3125 12.75 10.3125C12.4393 10.3125 12.1875 10.0607 12.1875 9.75V8.03514L9.5625 9.34764V16.428C10.1009 16.2939 10.7136 15.9724 11.6833 15.4635L13.1833 14.6764C14.797 13.8295 15.6039 13.4061 16.052 12.6452C16.5 11.8843 16.5 10.9375 16.5 9.04387V8.95613C16.5 7.53664 16.5 6.64918 16.3113 5.97326Z"
      fill="#878787"
    />
    <path
      d="M8.4375 16.428V9.34764L1.68873 5.97326C1.5 6.64918 1.5 7.53664 1.5 8.95613V9.04387C1.5 10.9375 1.5 11.8843 1.94805 12.6452C2.39609 13.4061 3.20297 13.8295 4.81671 14.6764L6.31672 15.4635C7.28643 15.9724 7.89906 16.2939 8.4375 16.428Z"
      fill="#878787"
    />
    <path
      d="M2.21977 4.98099L9 8.37111L11.5584 7.09192L4.89342 3.28339L4.81672 3.32364C3.48641 4.02175 2.70443 4.43212 2.21977 4.98099Z"
      fill="#878787"
    />
  </svg>
);

export const TrolleyIconGrey = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.17332 6.54787L7.55914 7.94442C7.9229 9.2611 8.10478 9.91943 8.63952 10.2189C9.17426 10.5183 9.85303 10.3419 11.2106 9.98911L12.6505 9.6149C14.008 9.2621 14.6868 9.0857 14.9955 8.56706C15.3043 8.04842 15.1224 7.39008 14.7587 6.07341L14.3728 4.67685C14.0091 3.36017 13.8272 2.70183 13.2925 2.4024C12.7577 2.10296 12.0789 2.27936 10.7214 2.63216L9.28148 3.00637C7.92393 3.35917 7.24516 3.53557 6.93642 4.05421C6.62769 4.57285 6.80957 5.23119 7.17332 6.54787Z"
      fill="#878787"
    />
    <path
      d="M1.70812 3.93521C1.79117 3.63586 2.10117 3.46051 2.40053 3.54357L3.6783 3.89808C4.36597 4.08887 4.91018 4.61899 5.10002 5.30617L6.71329 11.1457L6.83201 11.5556C7.30687 11.7329 7.71472 12.065 7.97357 12.5061L8.20606 12.4343L14.8587 10.7054C15.1593 10.6273 15.4664 10.8077 15.5446 11.1083C15.6227 11.409 15.4423 11.7161 15.1416 11.7942L8.51363 13.5167L8.26711 13.5928C8.26205 14.5461 7.60443 15.4166 6.60927 15.6752C5.41642 15.9852 4.19032 15.2986 3.87069 14.1417C3.55107 12.9848 4.25896 11.7956 5.45181 11.4856C5.51092 11.4702 5.57012 11.4573 5.62928 11.4468L4.01564 5.60575C3.93444 5.31182 3.69673 5.07069 3.37753 4.98213L2.09976 4.62762C1.80041 4.54456 1.62506 4.23456 1.70812 3.93521Z"
      fill="#878787"
    />
  </svg>
);

export const DownloadIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5 6.1125V0.75C7.5 0.551088 7.42098 0.360322 7.28033 0.21967C7.13967 0.0790176 6.94891 0 6.75 0C6.55108 0 6.36032 0.0790176 6.21967 0.21967C6.07901 0.360322 6 0.551088 6 0.75V6.1125L4.335 4.0305C4.27465 3.95018 4.19879 3.8828 4.11191 3.83236C4.02503 3.78192 3.9289 3.74945 3.82922 3.73687C3.72955 3.7243 3.62837 3.73188 3.53168 3.75916C3.43499 3.78644 3.34477 3.83287 3.26637 3.89569C3.18797 3.95851 3.12299 4.03644 3.07529 4.12485C3.02759 4.21327 2.99814 4.31037 2.98868 4.41038C2.97923 4.5104 2.98996 4.6113 3.02025 4.70708C3.05054 4.80287 3.09976 4.8916 3.165 4.968L6.165 8.718C6.23527 8.80559 6.32432 8.87629 6.42557 8.92487C6.52682 8.97344 6.63769 8.99866 6.75 8.99866C6.8623 8.99866 6.97317 8.97344 7.07442 8.92487C7.17567 8.87629 7.26472 8.80559 7.335 8.718L10.335 4.968C10.4002 4.8916 10.4495 4.80287 10.4797 4.70708C10.51 4.6113 10.5208 4.5104 10.5113 4.41038C10.5019 4.31037 10.4724 4.21327 10.4247 4.12485C10.377 4.03644 10.312 3.95851 10.2336 3.89569C10.1552 3.83287 10.065 3.78644 9.96831 3.75916C9.87162 3.73188 9.77044 3.7243 9.67077 3.73687C9.5711 3.74945 9.47497 3.78192 9.38808 3.83236C9.3012 3.8828 9.22534 3.95018 9.165 4.0305L7.5 6.1125Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.99275 9.6555L3.2685 7.5H1.5C1.10218 7.5 0.720644 7.65804 0.43934 7.93934C0.158035 8.22064 0 8.60218 0 9V12C0 12.3978 0.158035 12.7794 0.43934 13.0607C0.720644 13.342 1.10218 13.5 1.5 13.5H12C12.3978 13.5 12.7794 13.342 13.0607 13.0607C13.342 12.7794 13.5 12.3978 13.5 12V9C13.5 8.60218 13.342 8.22064 13.0607 7.93934C12.7794 7.65804 12.3978 7.5 12 7.5H10.2315L8.5065 9.6555C8.29571 9.91896 8.02836 10.1316 7.72424 10.2778C7.42013 10.4239 7.08704 10.4998 6.74963 10.4998C6.41221 10.4998 6.07912 10.4239 5.77501 10.2778C5.47089 10.1316 5.20354 9.91896 4.99275 9.6555ZM10.5 9.75C10.3011 9.75 10.1103 9.82902 9.96967 9.96967C9.82902 10.1103 9.75 10.3011 9.75 10.5C9.75 10.6989 9.82902 10.8897 9.96967 11.0303C10.1103 11.171 10.3011 11.25 10.5 11.25H10.5075C10.7064 11.25 10.8972 11.171 11.0378 11.0303C11.1785 10.8897 11.2575 10.6989 11.2575 10.5C11.2575 10.3011 11.1785 10.1103 11.0378 9.96967C10.8972 9.82902 10.7064 9.75 10.5075 9.75H10.5Z"
      fill="white"
    />
  </svg>
);

export const NotificationIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C8.13 2 5 5.13 5 9C5 14.25 2 16 2 16H22C22 16 19 14.25 19 9C19 5.13 15.87 2 12 2Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
